<template>
	<div style="background-color: #fff;padding: 20px;" class="container-top">
		<!-- 右上角 返回按钮 -->
		<div class="header">
			<a-button @click="goBack" class="back-btn">
				<a-icon type="left" /> 返回
			</a-button>
		</div>
		<a-form :form="form" :label-col="{ span: 3 }" :wrapper-col="{ span: 8 }" @submit.prevent="baseInfoSubmit">>
			<a-form-item label="广告位置">
				<a-select v-decorator="[
			      'bannerType',
			      { rules: [{ required: true, message: '请选择广告位置!' }] },
			    ]" placeholder="请选择广告位置">
					<a-select-option value="FACTORY">
						工厂首页
					</a-select-option>
					<a-select-option value="BRAND">
						品牌首页
					</a-select-option>
				</a-select>
			</a-form-item>
			<a-form-item label="广告标题">
				<a-input placeholder="请填写广告标题"
					v-decorator="['bannerTitle', { rules: [{ required: true, message: '请填写广告标题!' }] }]" />
			</a-form-item>
			<a-form-item label="顺序">
				<a-input placeholder="顺序" type="number" v-decorator="['sort']" />
				<span>数字越大越靠前</span>
			</a-form-item>

			<!-- 开始时间 -->
			<a-form-item label="开始时间">
				<a-date-picker style="width: 100%;" format="YYYY-MM-DD HH:mm:ss" valueFormat="YYYY-MM-DD HH:mm:ss" show-time
					v-decorator="['startTime', { rules: [{ required: true, message: '请选择开始时间!', trigger: 'change' }] }]" />
			</a-form-item>

			<!-- 到期时间 -->
			<a-form-item label="到期时间">
				<a-date-picker style="width: 100%;" format="YYYY-MM-DD HH:mm:ss" valueFormat="YYYY-MM-DD HH:mm:ss" show-time
					v-decorator="['endTime', { rules: [{ required: true, message: '请选择到期时间!', trigger: 'change' }, { validator: this.validateEndTime, trigger: 'change' }] }]" />
			</a-form-item>

			<!-- 发布状态 -->
			<a-form-item label="发布状态">
				<a-switch v-decorator="[
					'bannerStatus',
					{
						rules: [{ required: false, message: '请选择发布状态' }],
						initialValue: false,
						valuePropName: 'checked'
					}
					]" checked-text="已发布" unchecked-text="未发布"></a-switch>
			</a-form-item>

			<a-form-item label="图片/视频">
				<!-- 新增隐藏域，注册bannerUrl字段 -->
				<a-input hidden v-decorator="['bannerUrl', { rules: [{ required: true, message: '请上传广告图片!', trigger: 'change' }] }]"></a-input>
				<a-input hidden v-decorator="['videoUrl']"></a-input>
				<a-radio-group v-decorator="['bannerImageType',{initialValue: 'IMAGE' }]">
					<a-radio value="IMAGE">图片</a-radio>
					<a-radio value="VIDEO">视频</a-radio>
				</a-radio-group>

				<!-- 图片 -->
				<div v-if="form.getFieldValue('bannerImageType') == 'IMAGE'">
					<div style="display: flex;align-items: center;">
						<div style="font-weight: 700;margin-right: 10px;">上传图片</div>
						<div v-if="detailModel.bannerUrl">
							<viewer :images="[detailModel.bannerUrl]">
								<div class="er_content">
									<img class="er_content_img" :src="img"
										v-for="(img,index) in [detailModel.bannerUrl]" :key="index">
								</div>
							</viewer>
						</div>
						<div style="display:flex;align-items:center;">
						<div class="again_upload_box ml12">
							<a-spin v-if="imageUploadLoading" size="small" style="width:80px;height:80px;display:flex;align-items:center;justify-content:center;" />
							<input v-else type="file" accept="image/" @change="handleUpdataFile" />
							<i v-if="!imageUploadLoading" class="el-icon-box again_upload_icon"></i>
							<div v-if="!imageUploadLoading" class="bold" style="width: 100px">
								{{ detailModel.bannerUrl ? "重新上传" : "上传图片" }}
							</div>
						</div>
					</div>
					</div>

					<div style="color: #999; font-size: 12px; margin-top: 4px;">只能上传jpg/png格式文件，单文件不能超过3M</div>
				</div>

				<!-- 视频 -->
				<div v-if="form.getFieldValue('bannerImageType') == 'VIDEO'">
					<div style="display: flex;align-items: center;">
						<div style="font-weight: 700;margin-right: 10px;">上传封面</div>
						<div v-if="detailModel.bannerUrl">
							<viewer :images="[detailModel.bannerUrl]">
								<div class="er_content">
									<img class="er_content_img" :src="img"
										v-for="(img,index) in [detailModel.bannerUrl]" :key="index">
								</div>
							</viewer>
						</div>
						<div class="again_upload_box ml12">
							<a-spin v-if="coverUploadLoading" size="small" style="width:80px;height:80px;display:flex;align-items:center;justify-content:center;" />
							<input v-else type="file" accept="image/*" @change="uploadVideoCover" />
							<i v-if="!coverUploadLoading" class="el-icon-box again_upload_icon"></i>
							<div v-if="!coverUploadLoading" class="bold" style="width: 100px">
								{{ detailModel.videoImage ? "重新上传封面" : "上传封面" }}
							</div>
						</div>
					</div>
					<div style="color: #999; font-size: 12px; margin-top: 4px;">只能上传jpg/png格式文件，单文件不能超过3M</div>

					<div style="display: flex;align-items: center;margin-top: 30px;">
						<div style="font-weight: 700;margin-right: 10px;">上传视频</div>
						<div v-if="detailModel.videoUrl">
							<video :src="detailModel.videoUrl" style="width: 80px; height: 80px; object-fit: cover;"
								controls></video>
						</div>
						<div class="again_upload_box ml12">
							<a-spin v-if="videoUploadLoading" size="small" style="width:80px;height:80px;display:flex;align-items:center;justify-content:center;" />
							<input v-else type="file" accept="video/*" @change="uploadVideoFile" />
							<i v-if="!videoUploadLoading" class="el-icon-box again_upload_icon"></i>
							<div v-if="!videoUploadLoading" class="bold" style="width: 100px">
								{{ detailModel.videoUrl ? "重新上传视频" : "上传视频" }}
							</div>
						</div>
					</div>
				</div>
				<div  v-if="form.getFieldValue('bannerImageType') == 'VIDEO'"style="color: #999; font-size: 12px; margin-top: 4px;">只能上传mp4格式文件，文件不能超过10M</div>

			</a-form-item>

			<a-form-item label="跳转类型" v-if="form.getFieldValue('bannerImageType') !== 'VIDEO'">
				<a-select v-decorator="[
			      'jumpWxType',
			      { rules: [{ required: true, message: '请选择跳转类型!' }] },
			    ]" placeholder="请选择跳转类型" @change="handleJumpTypeChange">
					<a-select-option v-for="item in $enums.jumpTypeEnum" :key="item.value"
						:value="item.value">{{ item.label }}</a-select-option>
				</a-select>
				<!-- 跳转类型
				 WXAPP   小程序内部页面跳转、
				 URL 外部链接、
				 BANNER_DETAIL banner详情
				 BANNER_DETAIL_URL　banner详情页+跳转
				  -->

				<!-- 小程序内部页面跳转、 -->
				<div v-if="form.getFieldValue('jumpWxType') == 'WXAPP'">
					<div>跳转到小程序内部页面</div>
					<div style="display:flex;flex-direction:column;gap:12px;">
						<div style="display:flex;align-items:center;gap:12px;">
							<a-radio :checked="detailModel.jumpWxType === 'FACTORY'" @change="detailModel.jumpWxType='FACTORY';detailModel.jumpId=undefined">工厂详情</a-radio>
							<a-select v-if="detailModel.jumpWxType === 'FACTORY'" v-model="detailModel.jumpId" placeholder="请选择工厂" style="width: 300px;" show-search :filter-option="filterOption">
								<a-select-option v-for="item in factoryList" :key="item.businessId" :value="item.businessId">{{ item.businessName }}</a-select-option>
							</a-select>
						</div>
						<div style="display:flex;align-items:center;gap:12px;">
							<a-radio :checked="detailModel.jumpWxType === 'BRAND'" @change="detailModel.jumpWxType='BRAND';detailModel.jumpId=undefined">品牌详情</a-radio>
							<a-select v-if="detailModel.jumpWxType === 'BRAND'" v-model="detailModel.jumpId" placeholder="请选择品牌" style="width: 300px;" show-search :filter-option="filterOption">
								<a-select-option v-for="item in brandList" :key="item.businessId" :value="item.businessId">{{ item.businessName }}</a-select-option>
							</a-select>
						</div>
						<div><a-radio :checked="detailModel.jumpWxType === 'OEMINQUIRY'" @change="detailModel.jumpWxType='OEMINQUIRY'">代工咨询</a-radio></div>
						<div><a-radio :checked="detailModel.jumpWxType === 'EXECUTION_STANDARD'" @change="detailModel.jumpWxType='EXECUTION_STANDARD'">执行标准</a-radio></div>
						<div><a-radio :checked="detailModel.jumpWxType === 'REGULATION'" @change="detailModel.jumpWxType='REGULATION'">法律法规</a-radio></div>
						<div><a-radio :checked="detailModel.jumpWxType === 'COMPLAINT_GUIDE'" @change="detailModel.jumpWxType='COMPLAINT_GUIDE'">投诉指南</a-radio></div>
						<div><a-radio :checked="detailModel.jumpWxType === 'FEEDBACK'" @change="detailModel.jumpWxType='FEEDBACK'">意见反馈</a-radio></div>
					</div>
				</div>

				<!-- 外部链接、 v-decorator="['jumpUrl']"-->
				<div v-if="form.getFieldValue('jumpWxType') == 'URL'">
					<div>点击banner图片后直接跳转到外部链接</div>
					<!-- 外部链接地址 -->
					<a-input placeholder="请填写外部链接" v-model="detailModel.jumpUrl" />
				</div>
				<!-- banner详情 -->
				<div v-if="form.getFieldValue('jumpWxType') == 'BANNER_DETAIL'">
					<div>点击后显示详情页面，不在跳转</div>
					<a-input placeholder="详情页标题" v-model="detailModel.jumpTitle" />
					<div ref="wangEditorBannerDetail" style="margin-top:8px;z-index:1;position:relative;margin-bottom:60px;"></div>
				</div>
				<!-- banner详情+复制链接 -->
				<div v-if="form.getFieldValue('jumpWxType') == 'BANNER_URL_COPY'">
					<div>显示详情页，用户可复制链接</div>
					<a-input placeholder="详情页标题" v-model="detailModel.jumpTitle" />
					<div ref="wangEditorBannerUrlCopy" style="margin-top:8px;z-index:1;position:relative;margin-bottom:12px;"></div>
					<div>链接地址</div>
					<a-input placeholder="请填写链接地址" v-model="detailModel.jumpUrl" style="width: 700px;" />
				</div>
				<!-- banner详情页+跳转 -->
				<div v-if="form.getFieldValue('jumpWxType') == 'BANNER_DETAIL_URL'">
					<div>先显示详情页，用户可以在详情页选择跳转</div>
					<a-input placeholder="详情页标题" v-model="detailModel.jumpTitle" />
					<div ref="wangEditorBannerDetailUrl" style="margin-top:8px;z-index:1;position:relative;"></div>
					<a-select v-model="detailModel.jumpDetailType" placeholder="请选择跳转类型">
						<a-select-option v-for="item in $enums.jumpTypeinnerEnum" :key="item.value"
							:value="item.value">{{ item.label }}</a-select-option>
					</a-select>
					<div v-if="detailModel.jumpDetailType === 'WXAPP'">
						<div>小程序内部页面</div>
						<a-radio-group v-model="detailModel.jumpDetailWxType" style="display:flex;flex-direction:column;gap:12px;width:100%;">
							<div style="display:flex;align-items:center;gap:12px;">
								<a-radio value="FACTORY">工厂详情</a-radio>
								<a-select v-if="detailModel.jumpDetailWxType === 'FACTORY'" v-model="detailModel.jumpDetailId" placeholder="请选择工厂" style="width: 300px;" show-search :filter-option="filterOption">
									<a-select-option v-for="item in factoryList" :key="item.businessId" :value="item.businessId">{{ item.businessName }}</a-select-option>
								</a-select>
							</div>
							<div style="display:flex;align-items:center;gap:12px;">
								<a-radio value="BRAND">品牌详情</a-radio>
								<a-select v-if="detailModel.jumpDetailWxType === 'BRAND'" v-model="detailModel.jumpDetailId" placeholder="请选择品牌" style="width: 300px;" show-search :filter-option="filterOption">
									<a-select-option v-for="item in brandList" :key="item.businessId" :value="item.businessId">{{ item.businessName }}</a-select-option>
								</a-select>
							</div>
							<div><a-radio value="OEMINQUIRY">代工咨询</a-radio></div>
							<div><a-radio value="EXECUTION_STANDARD">执行标准</a-radio></div>
							<div><a-radio value="REGULATION">法律法规</a-radio></div>
							<div><a-radio value="COMPLAINT_GUIDE">投诉指南</a-radio></div>
							<div><a-radio value="FEEDBACK">意见反馈</a-radio></div>
						</a-radio-group>
						<!-- <div style="margin-top:12px;" v-if="innerType == 'FACTORY_DETAIL'">
							<a-form-item label="工厂详情">
								<div>todo</div>
							</a-form-item>
						</div>

						<div style="margin-top:12px;" v-if="innerType == 'BRAND_DETAIL'">
							<a-form-item label="品牌详情">
								<div>todo</div>
							</a-form-item>
						</div> -->
					</div>
					<div v-if="detailModel.jumpDetailType === 'URL'">
						<div>外部链接</div>
						<a-input placeholder="请填写外部链接" v-model="detailModel.jumpDetailUrl" />
					</div>
				</div>
			</a-form-item>
			<a-form-item :wrapper-col="{ span: 12, offset: 5 }">
				<a-button type="primary" html-type="submit">
					保存
				</a-button>
				<a-button v-if="form.getFieldValue('jumpWxType') === 'BANNER_DETAIL' || form.getFieldValue('jumpWxType') === 'BANNER_DETAIL_URL' || form.getFieldValue('jumpWxType') === 'BANNER_URL_COPY'"
					type="default" @click="handlePreview" style="margin-left: 12px;" :loading="previewLoading">
					预览
				</a-button>
			</a-form-item>

		</a-form>

		<a-modal title="二维码预览" :visible="previewModalVisible" @cancel="previewModalVisible = false" :footer="null">
			<div style="text-align: center; padding: 20px;">
				<img v-if="previewQRCodeUrl" :src="previewQRCodeUrl" style="max-width: 100%; max-height: 400px;" />
				<a-spin v-else />
			</div>
		</a-modal>

	</div>
</template>

<script>
	import moment from 'moment'
import E from 'wangeditor'
	import {
		ossUpload
	} from "../../utils/oss";
	import {
		getBannerDetailApi,
		saveBannerApi,
		getBusinessEntitiesApi
	} from "../../api/index";

	export default {
		name: "ADDETAIL",
		data() {
			return {
				"factoryThumbnail": "/uploads/thumbnail/factory1.jpg",
				bannerUrl: "",
				form: this.$form.createForm(this),
				detailModel: {
					"bannerId": 1,
					editorDetail: null,
					editorDetailUrl: null,
					editorUrlCopy: null,
					"bannerType": "", //广告位置 FACTORY 工厂 、BRAND 品牌
					"bannerTitle": "", //广告标题
					"bannerUrl": "", //banner图/视频封面
					"jumpType": "", //跳转类型：WXAPP  小程序URL 外部地址 BANNER_DETAIL banner详情BANNER_DETAIL_URL　banner 详情跳转
					"startTime": "", //开始日期
					"endTime": "", //结束日期
					"sort": 1, //排序
					"viewNum": 1,
					"bannerImageType": "", //IMAGE 图片 VIDEO视频
					"videoUrl": "", //视频地址
					"jumpUrl": "", //外部URL地址
					"jumpWxType": "", //小程序跳转 FACTORY  工厂  BRAND 品牌OEMINQUIRY 代工咨询EXECUTION_STANDARD 执行标准
					// REGULATION 法律法规
					// COMPLAINT_GUIDE 投诉指南
					// FEEDBACK 意见反馈
					"jumpId": 1, //对应跳转ID
					"jumpTitle": "", //跳转详情页标题
					"jumpContent": "", //跳转详情页
					"jumpDetailType": undefined, // 详情页得跳转WXAPP  小程序URL 外部地址 BANNER_DETAIL banner详情BANNER_DETAIL_URL　banner 详情跳转
					"jumpDetailUrl": "", // 详情页得 外部URL地址
					"jumpDetailWxType": "",
					// 详情页得 FACTORY  工厂  BRAND 品牌OEMINQUIRY 代工咨询EXECUTION_STANDARD 执行标准
					// REGULATION 法律法规
					// COMPLAINT_GUIDE 投诉指南
					// FEEDBACK 意见反馈
					"jumpDetailId": undefined, // 详情页得 对应跳转ID
				},
				commodityStatusList: [{
						label: "开启",
						value: true,
					},
					{
						label: "关闭",
						value: false,
					},
				],
				columns: [{
						title: "操作员",
						dataIndex: "operator",
						key: "operator",
					},
					{
						title: "操作",
						dataIndex: "operation",
						key: "operation",
					},
					{
						title: "时间",
						dataIndex: "operationTime",
						key: "operationTime",
					}
				],
				tableData: [],
				pageInfo: {
					pageSize: 20,
					current: 1,
					total: 0,
					showTotal: (total, range) => {
						return `合计 ${total} 条记录`;
					},
				},
				loading: false,
				bannerId: null,
				imageUploadLoading: false,
				coverUploadLoading: false,
				videoUploadLoading: false,
				factoryList: [],
				brandList: [],

				innerType: undefined,
				previewModalVisible: false,
				previewQRCodeUrl: '',
				previewLoading: false,
			};
		},
		methods: {
			handlePreview() {
				const editor = this.detailModel.editorDetail || this.detailModel.editorDetailUrl || this.detailModel.editorUrlCopy;
				if (editor) {
					this.detailModel.jumpContent = editor.txt.html();
				}
				this.form.validateFields((err, values) => {
					if (err) return;
					let params = {
						"bannerId": this.bannerId && this.bannerId !== '0' ? this.bannerId : 0,
						"bannerType": values.bannerType,
						"bannerTitle": values.bannerTitle,
						"bannerUrl": values.bannerUrl,
						"jumpType": values.jumpWxType == 'no' ? null : values.jumpWxType,
						"startTime": values.startTime,
						"endTime": values.endTime,
						"sort": values.sort,
						"bannerStatus": values.bannerStatus,
						"bannerImageType": values.bannerImageType,
						"jumpId": this.detailModel.jumpId || values.jumpId,
					}
					if (values.bannerImageType === 'VIDEO' && values.videoUrl) {
						params.videoUrl = values.videoUrl
					}
					if (params.jumpType == "WXAPP") {
						params['jumpWxType'] = this.detailModel.jumpWxType
					}
					if (params.jumpType == 'URL') {
						params['jumpUrl'] = this.detailModel.jumpUrl
					}
					if (params.jumpType == "BANNER_DETAIL") {
						params['jumpId'] = this.detailModel.jumpId ?? 0
						params['jumpTitle'] = this.detailModel.jumpTitle
						params['jumpContent'] = this.detailModel.jumpContent
					}
					if (params.jumpType == "BANNER_DETAIL_URL") {
						params['jumpTitle'] = this.detailModel.jumpTitle
						params['jumpContent'] = this.detailModel.jumpContent
						params['jumpDetailType'] = this.detailModel.jumpDetailType
						if (this.detailModel.jumpDetailType == 'URL') {
							params['jumpDetailUrl'] = this.detailModel.jumpDetailUrl
						}
						if (this.detailModel.jumpDetailType == "WXAPP") {
							params['jumpDetailWxType'] = this.detailModel.jumpDetailWxType
							params['jumpDetailId'] = this.detailModel.jumpDetailId ?? 0
						}
					}
					if (params.jumpType == "BANNER_URL_COPY") {
						params['jumpId'] = this.detailModel.jumpId ?? 0
						params['jumpTitle'] = this.detailModel.jumpTitle
						params['jumpContent'] = this.detailModel.jumpContent
						params['jumpUrl'] = this.detailModel.jumpUrl
					}
					this.previewLoading = true;
					saveBannerApi(params, true).then(res => {
						if (res.resultStatus) {
							// 预览保存成功后同步 bannerId，避免再次点击保存时当作新增
							if (res.resultData.bannerId) {
								this.bannerId = res.resultData.bannerId;
								this.detailModel.bannerId = res.resultData.bannerId;
							}
							this.previewQRCodeUrl = res.resultData.qrcodeUrl;
							this.previewModalVisible = true;
						} else {
							this.$message.error(res.msg || '生成二维码失败');
						}
					}).catch(() => {
						this.$message.error('生成二维码失败');
					}).finally(() => {
						this.previewLoading = false;
					});
				});
			},
			goBack() {
				this.$router.back();
			},
			innerTypechangeTabTop() {
				this.loadBusinessList('FACTORY');
				this.loadBusinessList('BRABD');
			},
			handleJumpTypeChange(value) {
				// 销毁之前的编辑器
				['editorDetail', 'editorDetailUrl', 'editorUrlCopy'].forEach(key => {
					if (this.detailModel[key]) {
						this.detailModel[key].destroy();
						this.detailModel[key] = null;
					}
				});
				if (value === 'BANNER_DETAIL') {
					this.initBannerEditor('wangEditorBannerDetail', 'jumpContent');
				} else if (value === 'BANNER_DETAIL_URL') {
					this.initBannerEditor('wangEditorBannerDetailUrl', 'jumpContent');
				} else if (value === 'BANNER_URL_COPY') {
					this.initBannerEditor('wangEditorBannerUrlCopy', 'jumpContent');
				}
			},
			loadBusinessList(businessType) {
				getBusinessEntitiesApi({ businessType, pageNo: 1, pageSize: 999, businessStatus: true, factoryStatus: true }).then(res => {
					if (res.resultStatus) {
						if (businessType === 'FACTORY') {
							this.factoryList = res.resultData.dataList || [];
						} else {
							this.brandList = res.resultData.dataList || [];
						}
					}
				}).catch(err => {
					console.error(err);
				});
			},
			initBannerEditor(refName, contentKey) {
				this.$nextTick(() => {
					const editorRef = this.$refs[refName];
					if (!editorRef) return;
					const editor = new E(editorRef);
					editor.config.height = 300;
					editor.config.customUploadImg = (files, insert) => {
						files.forEach(file => {
							if (file.size > 3 * 1024 * 1024) {
								this.$message.error(file.name + ' 超过3MB限制');
								return;
							}
							ossUpload(file, '', 'image/').then(res => {
								insert(res.url);
							}).catch(() => {
								this.$message.error('图片上传失败');
							});
						});
					};
					editor.create();
					if (this.detailModel[contentKey]) {
						editor.txt.html(this.detailModel[contentKey]);
					}
					if (refName === 'wangEditorBannerDetail') {
						this.detailModel.editorDetail = editor;
					} else if (refName === 'wangEditorBannerDetailUrl') {
						this.detailModel.editorDetailUrl = editor;
					} else if (refName === 'wangEditorBannerUrlCopy') {
						this.detailModel.editorUrlCopy = editor;
					}
				});
			},
			sureEdit(formValues) {

				let params = {
					"bannerId": this.bannerId && this.bannerId !== '0' ? this.bannerId : 0,
					"bannerType": formValues.bannerType,
					"bannerTitle": formValues.bannerTitle,
					"bannerUrl": formValues.bannerUrl, // 现在formValues一定能拿到
					"jumpType": formValues.jumpWxType == 'no' ? null : formValues
						.jumpWxType,
					"startTime": formValues.startTime,
					"endTime": formValues.endTime,
					"sort": formValues.sort,
					"bannerStatus": formValues.bannerStatus,
					"bannerImageType": formValues.bannerImageType,
					"jumpId": this.detailModel.jumpId || formValues.jumpId,
					// "videoUrl":formValues.videoUrl
				}
				// 只有视频类型才携带videoUrl
				if (formValues.bannerImageType === 'VIDEO' && formValues.videoUrl) {
					params.videoUrl = formValues.videoUrl
				}
				// 跳转到小程序内部页面
				if (params.jumpType == "WXAPP") {
					params['jumpWxType'] = this.detailModel.jumpWxType
				}
				// 外部链接
				if (params.jumpType == 'URL') {
					params['jumpUrl'] = this.detailModel.jumpUrl
				}
				// banner详情
				if (params.jumpType == "BANNER_DETAIL") {
					params['jumpId'] = this.detailModel.jumpId ?? 0 //这个值不知道从哪里取来
					params['jumpTitle'] = this.detailModel.jumpTitle
					params['jumpContent'] = this.detailModel.jumpContent
				}
				// banner详情+跳转
				if (params.jumpType == "BANNER_DETAIL_URL") {
					params['jumpTitle'] = this.detailModel.jumpTitle
					params['jumpContent'] = this.detailModel.jumpContent
					params['jumpDetailType'] = this.detailModel.jumpDetailType

					if (this.detailModel.jumpDetailType == 'URL') {
						params['jumpDetailUrl'] = this.detailModel.jumpDetailUrl
					}
					if (this.detailModel.jumpDetailType == "WXAPP") {
						params['jumpDetailWxType'] = this.detailModel.jumpDetailWxType
						params['jumpDetailId'] = this.detailModel.jumpDetailId ?? 0
					}

				}
				// banner详情+复制链接
				if (params.jumpType == "BANNER_URL_COPY") {
					params['jumpId'] = this.detailModel.jumpId ?? 0
					params['jumpTitle'] = this.detailModel.jumpTitle
					params['jumpContent'] = this.detailModel.jumpContent
					params['jumpUrl'] = this.detailModel.jumpUrl
				}
				let jumpType = params['jumpType'];
				let jumpWxType =  params['jumpWxType'];
				let  jumpId = params['jumpId']

				console.log(params)
				if(jumpType == "WXAPP" &&   !jumpWxType){
					this.$message.warning('请选择跳转类型');
					return;
				}
				if(jumpType == "WXAPP" &&   (jumpWxType == "FACTORY"  || jumpWxType == "BRAND" )&& !jumpId){
					this.$message.warning('请选择跳转页面');
					return;
				}
				if(jumpType == "URL" &&   ! params['jumpUrl']){
					this.$message.warning('请填写外部链接');
					return;
				}
				if(jumpType == "BANNER_DETAIL" &&  ( ! params['jumpTitle'] )){
					this.$message.warning('请填写广告标题');
					return;
				}
				if(jumpType == "BANNER_DETAIL" &&  ( ! params['jumpContent'] )){
					this.$message.warning('请填写广告详情');
					return;
				}
				if(jumpType == "BANNER_DETAIL_URL" &&  ( ! params['jumpTitle'] )){
					this.$message.warning('请填写广告标题');
					return;
				}
				if(jumpType == "BANNER_DETAIL_URL" &&  ( ! params['jumpContent'] )){
					this.$message.warning('请填写广告详情');
					return;
				}
				if(jumpType == "BANNER_DETAIL_URL" &&  ( ! params['jumpDetailType'] )){
					this.$message.warning('请选择跳转类型');
					return;
				}

				if(jumpType == "BANNER_DETAIL_URL" &&  params['jumpDetailType'] == "WXAPP" &&
						(params['jumpDetailWxType'] == "FACTORY"  || params['jumpDetailWxType'] == "BRAND" ) && !params['jumpDetailId']){
					this.$message.warning('请选择跳转页面');
					return;
				}
				if(jumpType == "BANNER_DETAIL_URL" &&  params['jumpDetailType'] == "WXAPP" &&   (params['jumpDetailWxType'] == "no")){
					this.$message.warning('请选择跳转类型');
					return;
				}
				if(jumpType == "BANNER_DETAIL_URL"&& params['jumpDetailType'] == "URL" &&   ! params['jumpDetailUrl']){
					this.$message.warning('请填写外部链接');
					return;
				}
				if(jumpType == "BANNER_URL_COPY" &&  (!params['jumpTitle'])){
					this.$message.warning('请填写广告标题');
					return;
				}
				if(jumpType == "BANNER_URL_COPY" &&  (!params['jumpContent'])){
					this.$message.warning('请填写广告详情');
					return;
				}
				if(jumpType == "BANNER_URL_COPY" &&  (!params['jumpUrl'])){
					this.$message.warning('请填写链接地址');
					return;
				}
				if(jumpType == "BANNER_URL_COPY" && params['jumpUrl'] && !params['jumpUrl'].startsWith('http://') && !params['jumpUrl'].startsWith('https://')){
					this.$message.warning('请填写正确的链接地址（以 http:// 或 https:// 开头）');
					return;
				}
				saveBannerApi(params)
					.then((res) => {
						if (res.resultStatus) {
							this.$message.success(
								this.detailModel.bannerId ? "保存成功" : "保存成功"
							);
							this.$router.push({ name: 'ADMANAGE' });
						} else {
							this.$message.warning(
								res.errorMessage || ''
							);
						}
					})
					.catch((error) => {
						console.log(error)
						debugger
						this.$message.warning(
								error
						);
					})
					.finally(() => {})
			},
			baseInfoSubmit(e) {
				e.preventDefault();
				const editor = this.detailModel.editorDetail || this.detailModel.editorDetailUrl || this.detailModel.editorUrlCopy;
				if (editor) {
					this.detailModel.jumpContent = editor.txt.html();
				}
				this.form.validateFields((err, values) => {
					if (!err) {
						if (values.bannerImageType === 'VIDEO' && !values.videoUrl) {
							this.form.setFields({ videoUrl: { value: '', errors: [new Error('请上传广告视频!')] } });
							return;
						}
						this.sureEdit(values);
					}
				});
			},
			disabledDate(current) {
				return current && current < moment().subtract(1, 'days').endOf('day')
			},
			filterOption(input, option) {
				return (
					option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
				);
			},
			// 校验到期时间不能早于开始时间
			validateEndTime(rule, value, callback) {
				const startTime = this.form.getFieldValue('startTime');
				if (value && startTime && value < startTime) {
					callback('到期时间不能早于开始时间');
				} else {
					callback();
				}
			},
			// 上传视频封面
			uploadVideoCover(e) {
				const file = e.target.files[0];
				if (!file) return;
				this.coverUploadLoading = true;
				ossUpload(file, '', 'image/').then(res => {
					this.form.setFieldsValue({
						bannerUrl: res.url
					});
					this.detailModel.bannerUrl = res.url;
					this.$message.success("封面上传成功");
				}).catch(err => {
					this.$message.error("封面上传失败");
				}).finally(() => {
					this.coverUploadLoading = false;
					e.target.value = '';
				});
			},
			// 上传视频文件
			uploadVideoFile(e) {
				const file = e.target.files[0];
				if (!file) return;
				this.videoUploadLoading = true;
				ossUpload(file, '', 'video/').then(res => {
					this.form.setFieldsValue({
						videoUrl: res.url
					});
					this.detailModel.videoUrl = res.url;
					this.form && this.form.clearValidate && this.form.clearValidate('videoUrl');
					this.$message.success("视频上传成功");
				}).catch(err => {
					this.$message.error("视频上传失败");
				}).finally(() => {
					this.videoUploadLoading = false;
					e.target.value = '';
				});
			},
			handleUpdataFile(e) {
				const file = e.target.files[0];
				if (!file) return;
				if (file.size > 3 * 1024 * 1024) {
					this.$message.warning('图片大小不能超过3M');
					e.target.value = '';
					return;
				}
				this.imageUploadLoading = true;
				ossUpload(file, '', 'image/').then((res) => {
					this.form.setFieldsValue({
						bannerUrl: res.url
					});
					this.detailModel.bannerUrl = res.url;
					this.form && this.form.clearValidate && this.form.clearValidate('bannerUrl');
				}).catch(err => {
					this.$message.error('图片上传失败')
				}).finally(() => {
					this.imageUploadLoading = false;
					e.target.value = '';
				});
			},
			getDetails() {
				this.$nextTick(() => {
					getBannerDetailApi({
						bannerId: this.bannerId,
					}).then((res) => {
						if (res.resultStatus) {
							console.log(res, '或者这里')
							const result = res.resultData;
							this.detailModel = {
								"bannerId": result.bannerId ? result.bannerId : "",
								"bannerType": result.bannerType ? result.bannerType :
								"", //广告位置 FACTORY 工厂 、BRAND 品牌
								"bannerTitle": result.bannerTitle ? result.bannerTitle : "", //广告标题
								"bannerUrl": result.bannerUrl ? result.bannerUrl : "", //banner图/视频封面
								"bannerStatus": result.bannerStatus ? result.bannerStatus :
								false, //banner图/视频封面
								"jumpType": result.jumpType ? result.jumpType : "no", //跳转类型：WXAPP  小程序URL 外部地址 BANNER_DETAIL banner详情BANNER_DETAIL_URL　banner 详情跳转
								"startTime": result.startTime ? result.startTime : "", //开始日期
								"endTime": result.endTime ? result.endTime : "", //结束日期
								"sort": result.sort ? result.sort : '', //排序
								"viewNum": result.viewNum ? result.viewNum : '',
								"bannerImageType": result.bannerImageType ? result.bannerImageType :
									"", //IMAGE 图片 VIDEO视频
								"videoUrl": result.videoUrl ? result.videoUrl : "", //视频地址
								"jumpUrl": result.jumpUrl ? result.jumpUrl : "", //外部URL地址
								"jumpWxType": result.jumpWxType ? result.jumpWxType : "",
								"jumpId": result.jumpId ? result.jumpId : '', //对应跳转ID
								"jumpTitle": result.jumpTitle ? result.jumpTitle : "", //跳转详情页标题
								"jumpContent": result.jumpContent ? result.jumpContent : "", //跳转详情页
								"jumpDetailType": result.jumpDetailType || undefined, // 详情页得跳转WXAPP  小程序URL 外部地址 BANNER_DETAIL banner详情BANNER_DETAIL_URL　banner 详情跳转
								"jumpDetailUrl": result.jumpDetailUrl ? result.jumpDetailUrl :
								"", // 详情页得 外部URL地址
								"jumpDetailWxType": result.jumpDetailWxType ? result.jumpDetailWxType :
									"no",
								"jumpDetailId": result.jumpDetailId ? result.jumpDetailId :
									undefined // 详情页得 对应跳转ID
							};

							console.log(this.detailModel,
								'看看这里的问题呢============================================')
							// 新增：同步图片/视频类型到表单，单选框自动选中
							// this.form.setFieldsValue({
							// 	bannerImageType: result.bannerImageType || 'IMAGE'
							// })

							// 2. 批量回填 antd-vue form 所有 v-decorator 字段（关键修复）
							const formData = {
								bannerType: result.bannerType,
								bannerTitle: result.bannerTitle,
								bannerUrl: result.bannerUrl,
								bannerImageType: result.bannerImageType || "IMAGE",
								sort: result.sort ?? 1,
								"bannerStatus": result.bannerStatus ?? false,
								jumpWxType: result.jumpType || 'no', // 表单select绑定jumpWxType实际存jumpType
								jumpDetailType: result.jumpDetailType,
								videoUrl: result.videoUrl
							};

							console.log(formData, '看看这里的值好好好好')

							// 3. 时间字符串转moment对象，修复日期选择器回显空白
							if (result.startTime) {
								formData.startTime = moment(result.startTime).format('YYYY-MM-DD HH:mm:ss');
							}
							if (result.endTime) {
								formData.endTime = moment(result.endTime).format('YYYY-MM-DD HH:mm:ss');
							}

							// 表单批量赋值
							// 表单批量赋值
							this.form.setFieldsValue(formData);
							// 单独设置 jumpDetailType
							if (result.jumpDetailType) {
								this.form.setFields({
									jumpDetailType: { value: result.jumpDetailType, errors: [] }
								});
							}
							this.$forceUpdate();
							// 新增强制刷新表单控件
							this.form.validateFields(() => {});
							this.$nextTick(() => {
								console.log(this.form.getFieldValue('bannerStatus'), '艾小丽')
							})

							// 4. 回填内部跳转标识，控制innerType显隐工厂/品牌下拉
							this.innerType = result.jumpWxType;
							// 5. 初始化wangEditor
							if (result.jumpType === 'BANNER_DETAIL' || result.jumpType === 'BANNER_DETAIL_URL' || result.jumpType === 'BANNER_URL_COPY') {
								this.$nextTick(() => {
									let refName = 'wangEditorBannerDetail';
									if (result.jumpType === 'BANNER_DETAIL_URL') refName = 'wangEditorBannerDetailUrl';
									if (result.jumpType === 'BANNER_URL_COPY') refName = 'wangEditorBannerUrlCopy';
									this.initBannerEditor(refName, 'jumpContent');
								});
							}

						} else {
							this.$message.warn(res.errorMessage);
							this.detailModel = {
								"bannerId": "",
								"bannerType": "", //广告位置 FACTORY 工厂 、BRAND 品牌
								"bannerTitle": "", //广告标题
								"bannerUrl": "", //banner图/视频封面
								// 修复：bannerStauts → bannerStatus
								"bannerStatus": false,
								"jumpType": '', //跳转类型：WXAPP  小程序URL 外部地址 BANNER_DETAIL banner详情BANNER_DETAIL_URL　banner 详情跳转
								"startTime": "", //开始日期
								"endTime": "", //结束日期
								"sort": '', //排序
								"viewNum": '',
								"bannerImageType": "", //IMAGE 图片 VIDEO视频
								"videoUrl": "", //视频地址
								"jumpUrl": "", //外部URL地址
								"jumpWxType": "",
								"jumpId": '', //对应跳转ID
								"jumpTitle": "", //跳转详情页标题
								"jumpContent": "", //跳转详情页
								"jumpDetailType": undefined, // 详情页得跳转WXAPP  小程序URL 外部地址 BANNER_DETAIL banner详情BANNER_DETAIL_URL　banner 详情跳转
								"jumpDetailUrl": "", // 详情页得 外部URL地址
								"jumpDetailWxType": "",
								"jumpDetailId": null // 详情页得 对应跳转ID
							};
						}
					});

				})


			},
		},
		mounted() {
			this.innerTypechangeTabTop();
			// 接收从列表传过来的 bannerId
			const bannerId = this.$route.params.id;
			this.bannerId = bannerId
			if (bannerId && bannerId !== '0') {
				this.getDetails(this.bannerId)
			} else {
				this.bannerId = 0;
				this.form.setFieldsValue({
					bannerImageType: 'IMAGE',
					bannerStatus: false // 新增默认未发布
				})
			}
		},
		activated() {},
	};
</script>

<style lang="less" scoped>
	.container-top {
		padding: 20px;
		background-color: #fff;

		/* 右上角按钮 */
		.header {
			text-align: right;
			margin-bottom: 16px;
		}

		.title {
			font-size: 18px;
			color: #333333;
			line-height: 18px;
			// margin-bottom: 30px;
		}

		.titleCz {
			font-size: 18px;
			font-size: 18px;
			color: #333333;
			line-height: 18px;
			margin-bottom: 30px;
		}

		.ant-form-item {
			// margin-bottom: 0px !important;
		}
	}
</style>
<style>
/* wangEditor 下拉菜单裁剪修复 */
.w-e-toolbar {
	z-index: 99999 !important;
}
</style>
